/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { Navigate, useParams } from 'react-router';

/* Import configuration */
import { APP_ROUTES } from '@/config/appRoutes';
import { OVERVIEW_ANOMALY_CONFIGS } from '@/config/kpi/overviewAnomalyConfig';

/* Import components */
import SystemDashboardOverview from '@/components/tabs/overview/system/SystemDashboardOverview';

function SystemDetailTab() {
    const { systemKey } = useParams<{ systemKey: string }>();

    if (!systemKey) {
        return <Navigate to={APP_ROUTES.systems} replace />;
    }

    return (
        <SystemDashboardOverview
            anomalyConfigs={OVERVIEW_ANOMALY_CONFIGS}
            systemKey={systemKey}
        />
    );
}

export default SystemDetailTab;
